import {
  createBrowserRouter,
  RouterProvider,
  useLocation,
  useNavigate,
} from "react-router-dom";

// MANTINE IMPORTS
import "@mantine/carousel/styles.css";
import {
  createTheme as createMantineTheme,
  MantineProvider,
} from "@mantine/core";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/dropzone/styles.css";
import "@mantine/carousel/styles.css";
import "@mantine/dates/styles.css";

import { Notifications } from "@mantine/notifications";

import Login from "./Pages/Login";

import "./styles/index.scss";
import Dashboard from "./Pages/Dashboard";
import Overview from "./Pages/Overview";
import Team from "./Pages/Team";
import Plans from "./Pages/Plans";
import Courses from "./Pages/Courses";
import SingleCourse from "./Pages/SingleCourse";
import Teachers from "./Pages/Teachers";
import { useEffect } from "react";
import Blogs from "./Pages/Blogs";
import SingleBlogEdit from "./Pages/SingleBlog/Edit";
import SingleBlogView from "./Pages/SingleBlog/View";
import Students from "./Pages/Students";
import Transactions from "./Pages/Transactions";
import Error404 from "./Pages/Error404";
import CompleteOnboarding from "./Pages/CompleteOnboarding";
import SingleStudent from "./Pages/SingleStudent";
import SingleLessonLiveKit from "./Pages/SingleLessonLiveKit";
const mantineTheme = createMantineTheme({});
function RedirectWhereNecessary() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("t");

    if (!token) {
      navigate("/login");
    } else {
      navigate("/d");
    }
  }, [location.pathname, navigate]);

  return <></>;
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <RedirectWhereNecessary />,
  },
  {
    path: "*",
    element: <Error404 />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/onboard/:token",
    element: <CompleteOnboarding />,
  },
  {
    path: "/d",
    element: <Dashboard />,
    children: [
      {
        path: "/d/overview",
        element: <Overview />,
      },
      {
        path: "/d/team",
        element: <Team />,
      },
      {
        path: "/d/plans",
        element: <Plans />,
      },
      {
        path: "/d/courses",
        element: <Courses />,
      },
      {
        path: "/d/course/:courseID",
        element: <SingleCourse />,
      },
      {
        path: "/d/room/:lessonID/:batchID",
        element: <SingleLessonLiveKit />,
      },
      {
        path: "/d/teachers",
        element: <Teachers />,
      },
      {
        path: "/d/blogs",
        element: <Blogs />,
      },
      {
        path: "/d/blog-edit/:blogID",
        element: <SingleBlogEdit />,
      },
      {
        path: "/d/blog-view/:blogID",
        element: <SingleBlogView />,
      },
      {
        path: "/d/students",
        element: <Students />,
      },
      {
        path: "/d/student/:studentID",
        element: <SingleStudent />,
      },
      {
        path: "/d/billing",
        element: <Transactions />,
      },
    ],
  },
]);

export default function App() {
  return (
    <MantineProvider theme={mantineTheme}>
      <Notifications
        styles={{
          root: {
            zIndex: 9999999999999,
          },
        }}
        position="bottom-right"
      />
      <RouterProvider router={router} />
    </MantineProvider>
  );
}
